export default {
  english: {
    label: 'Share on X',
  },
  french: {
    label: 'Partager sur X',
  },
  arabic: {
    label: 'انشر على X',
  },
  hebrew: {
    label: 'שתף ב-X',
  },
  persian: {
    label: 'در X به اشتراک بگذارید',
  },
}
